import { toContactPage } from '@portalCommon/utils';
import classnames from 'classnames/bind';
import { ContactType } from 'common-package';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const ContactUs = ({ title }: { title?: string }) => {
  return (
    <div className={cx('contact-us-container')}>
      <div className={cx('content')}>
        <div className={cx('text')}>{title ?? '为您量身定制企业空间解决方案'}</div>
        <div
          className={cx('btn')}
          onClick={() =>
            toContactPage({ contactType: ContactType.activity, isMain: import.meta.env.VITE_MAIN === 'true' })
          }>
          联系我们
        </div>
      </div>
    </div>
  );
};
